import { createFileRoute, redirect } from '@tanstack/react-router';

import { FRONTPAGE_HOME } from '@/lib/frontpage';
import { adminListFrontpageFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/frontpage')({
    loader: async () => {
        const { rows } = await adminListFrontpageFn();
        const home = rows.find((row) => row.key === FRONTPAGE_HOME);
        const target = home ?? rows[0];
        throw redirect({
            to: '/admin/frontpage/$id',
            params: { id: target?.id ?? 'new' },
        });
    },
});
